import { CheckCircleIcon } from '@langchain/untitled-ui-icons';

import React from 'react';

export const UserJourney = (props: {
  steps: string[];
  currentIndex: number;
}) => {
  return (
    <div className="inline-flex items-center gap-3">
      {props.steps.map((step, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <div className="h-[1px] max-w-[100px] grow bg-black  dark:bg-white" />
          )}
          <div className="inline-flex items-center gap-1">
            {index < props.currentIndex ? (
              <CheckCircleIcon className="size-4" />
            ) : index === props.currentIndex ? (
              <div className="flex h-[22px] w-[22px] items-center justify-center rounded-full border-2 border-brand">
                <div className="h-4 w-4 rounded-full border border-black dark:border-white" />
              </div>
            ) : (
              <div className="h-4 w-4 rounded-full border border-black dark:border-white" />
            )}
            {step}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};
